import { render, staticRenderFns } from "./CustomSquare.vue?vue&type=template&id=39874787&"
import script from "./CustomSquare.vue?vue&type=script&lang=js&"
export * from "./CustomSquare.vue?vue&type=script&lang=js&"
import style0 from "./CustomSquare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports